import React, { ReactElement, useState } from 'react';
import { Row, Layout, Col, Typography, Space, Card, Button, Tag, Modal } from 'antd';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import moment from 'moment';
import { getDateWithTime } from '../../../utils/dateTimeUtils';
import { toSentenceCase } from '../../../utils/customPipeUtil';
import { getIconBasedOnFile } from '../abdmUtils';
import { useDispatch } from 'react-redux';
import { previewDocuments, submitAdmission } from '../../../store/actions/fileAction';

const { Text } = Typography;

const CommonCard = (props: any): ReactElement => {
  const { data } = props || {};
  const dispatch = useDispatch();
  const [previewDocument, setPreviewDocument] = useState(false);
  const [linkSource, setLinkSource] = useState('');
  const download = (file: any): void => {
    dispatch(submitAdmission(file?.fileId));
    dispatch(previewDocuments(file?.fileId, getPDFViewer));
    setPreviewDocument(true);
  };
  const getPDFViewer = (info: any): void => {
    setLinkSource(info);
    const { fileName, isSuccess, fileBytes } = info || {};
    if (isSuccess) {
      let urlType = '';
      urlType = fileName?.split('.')[1] !== 'pdf' ? 'image/png' : 'application/pdf';
      setLinkSource('data:' + `${urlType}` + ';base64,' + fileBytes);
    }
  };
  const onModalCancel = (): any => {
    setLinkSource('');
    setPreviewDocument(false);
  };

  return (
    <div className="common-card">
      <Row gutter={GUTTOR_SPACE}>
        <Col md={24}>
          <Layout className="banner-layout">
            <Row gutter={GUTTOR_SPACE}>
              <Col span={9}>
                <Text type="secondary">Document</Text>
                <Text className="ml-5">{data?.fhirTitle || ''}</Text>
              </Col>
              <Col span={9}>
                <Text type="secondary">Date</Text>
                <Text className="ml-5">{getDateWithTime(moment(data?.sectionUpdateDate))}</Text>
              </Col>
              <Col span={4}>
                <span>
                  <Text type="secondary">Status</Text>
                  <Text className="ml-5">{toSentenceCase(data?.fhirStatus)}</Text>
                </span>
              </Col>
            </Row>
          </Layout>
        </Col>
      </Row>
      <Space size="middle" direction="vertical" className="layout-content">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24}>
            <strong>
              <Text type="secondary">#Clinical consultation report:</Text>
              <Text className="ml-5">{data?.reportType}</Text>
            </strong>
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24}>
            <Card title="Enclosed clinical document(s)">
              <Row gutter={GUTTOR_SPACE}>
                {
                  (data?.files || [])?.map((file: any, index: number): any => (
                    <Col md={24} key={index + file?.fileId}>
                      <span className="index">
                        {index + 1}
                      </span>&nbsp;&nbsp;
                      <span className="fsize_sm">
                        <Tag>
                          <span className="gray-text">Status</span>&nbsp;
                          <strong>{toSentenceCase(file?.fileStatus)}</strong>
                        </Tag>
                      </span>
                      <span>
                        <Button
                          icon={getIconBasedOnFile(file?.fileName)}
                          type="link"
                          onClick={(): any => download(file)}
                        >
                          {file?.fileName}
                        </Button>
                      </span>
                      <Modal
                        visible={previewDocument}
                        onCancel={onModalCancel}
                        footer={null}
                        centered={true}
                        width="1520px"
                        bodyStyle={{ height: 595 }}
                      >
                        <Row>
                          <Col>
                            <iframe src={linkSource} width="1265" height="545" loading="lazy"/>
                          </Col>
                        </Row>
                      </Modal>
                    </Col>
                  ))
                }
              </Row>
            </Card>
          </Col>
        </Row>
      </Space>
    </div>
  );
};
export default CommonCard;
